var _a, _b;
export var FeatureId;
(function (FeatureId) {
    FeatureId["ThemeExport"] = "THEME_EXPORT";
})(FeatureId || (FeatureId = {}));
export var FeatureVisibility;
(function (FeatureVisibility) {
    FeatureVisibility["Hidden"] = "XX";
    FeatureVisibility["MadAdmins"] = "MA";
    FeatureVisibility["MadAdminsOptIn"] = "M+";
    FeatureVisibility["UserOptIn"] = "U+";
    FeatureVisibility["VisibleToAll"] = "VA";
})(FeatureVisibility || (FeatureVisibility = {}));
export var FileScanStatus;
(function (FileScanStatus) {
    FileScanStatus["Clean"] = "C";
    FileScanStatus["Error"] = "E";
    FileScanStatus["Quarantine"] = "Q";
    FileScanStatus["Pending"] = "P";
})(FileScanStatus || (FileScanStatus = {}));
export var ProtocolMode;
(function (ProtocolMode) {
    ProtocolMode["COP"] = "COP";
    ProtocolMode["LIPLOP"] = "LIPLOP";
})(ProtocolMode || (ProtocolMode = {}));
export var LangCode;
(function (LangCode) {
    LangCode["DE"] = "DE";
    LangCode["DK"] = "DK";
    LangCode["EN_GB"] = "EN_GB";
    LangCode["EN_US"] = "EN_US";
    LangCode["ES"] = "ES";
    LangCode["FR"] = "FR";
    LangCode["HE"] = "HE";
    LangCode["IT"] = "IT";
    LangCode["PT"] = "PT";
    LangCode["RU"] = "RU";
    LangCode["UA"] = "UA";
    LangCode["VL"] = "VL";
})(LangCode || (LangCode = {}));
export var DeviceConfigAudioType;
(function (DeviceConfigAudioType) {
    DeviceConfigAudioType["Floor"] = "floor";
    DeviceConfigAudioType["Direction"] = "direction";
    DeviceConfigAudioType["Gong"] = "gong";
})(DeviceConfigAudioType || (DeviceConfigAudioType = {}));
export var VolumeType;
(function (VolumeType) {
    VolumeType["Master"] = "masterVolume";
    VolumeType["Media"] = "mediaVolume";
    VolumeType["Synth"] = "synthVolume";
    VolumeType["Chime"] = "chimeVolume";
    VolumeType["Floor"] = "floorVolume";
    VolumeType["Direction"] = "directionVolume";
    VolumeType["ServiceMessage"] = "serviceMessageVolume";
    VolumeType["Buzzer"] = "buzzerVolume";
    VolumeType["Background"] = "backgroundVolume";
    VolumeType["FloorPassing"] = "floorPassingVolume";
})(VolumeType || (VolumeType = {}));
export var ServiceMessageType;
(function (ServiceMessageType) {
    ServiceMessageType["ALARM_SENT"] = "ALARM_SENT";
    ServiceMessageType["ALARM_RECEIVED"] = "ALARM_RECEIVED";
    ServiceMessageType["WEIGHT_TH1"] = "WEIGHT_TH1";
    ServiceMessageType["WEIGHT_TH2"] = "WEIGHT_TH2";
    ServiceMessageType["OVERLOAD"] = "OVERLOAD";
    ServiceMessageType["FIRE"] = "FIRE";
    ServiceMessageType["FIRE_ALT"] = "FIRE_ALT";
    ServiceMessageType["EMERGENCY"] = "EMERGENCY";
    ServiceMessageType["RETURN_TO_MAIN"] = "RETURN_TO_MAIN";
    ServiceMessageType["OUT_OF_SERVICE"] = "OUT_OF_SERVICE";
    ServiceMessageType["OUT_OF_SERVICE_ALT"] = "OUT_OF_SERVICE_ALT";
    ServiceMessageType["SHIPMENT"] = "SHIPMENT";
    ServiceMessageType["NORMAL"] = "NORMAL";
    // Candela // 13
    ServiceMessageType["PRIORITY"] = "PRIORITY";
    ServiceMessageType["INSPECTION"] = "INSPECTION";
    ServiceMessageType["CLEAR_DOOR"] = "CLEAR_DOOR";
    ServiceMessageType["DOOR_CLOSING"] = "DOOR_CLOSING";
    ServiceMessageType["DOOR_OPENING"] = "DOOR_OPENING";
    ServiceMessageType["MIND_STEP"] = "MIND_STEP";
    ServiceMessageType["CODE_BLUE"] = "CODE_BLUE";
    ServiceMessageType["CODE_BLUE_OVER"] = "CODE_BLUE_OVER";
    ServiceMessageType["EVACUATE"] = "EVACUATE";
    ServiceMessageType["ERROR"] = "ERROR";
    // FLOOR_A_FS // 24
    // FLOOR_A_PRES // 25
    ServiceMessageType["FLOOR_PRESENT"] = "FLOOR_PRESENT";
    // FLOOR_A_L13 // 26
    // FLOOR_A_AUX_3 // 27
    // FLOOR_B_FS // 28
    // FLOOR_B_PRES // 29
    // FLOOR_B_L13 // 30
    // FLOOR_B_AUX_3 // 31
    ServiceMessageType["AUX0"] = "AUX0";
    ServiceMessageType["AUX1"] = "AUX1";
    ServiceMessageType["AUX2"] = "AUX2";
    ServiceMessageType["AUX3"] = "AUX3";
    ServiceMessageType["AUX4"] = "AUX4";
    ServiceMessageType["AUX5"] = "AUX5";
    ServiceMessageType["AUX6"] = "AUX6";
    ServiceMessageType["AUX7"] = "AUX7";
    //
    // CAN TKE Memphis
    //
    ServiceMessageType["ATTENDANT_OPERATION"] = "ATTENDANT_OPERATION";
    ServiceMessageType["AUTO_RETURN"] = "AUTO_RETURN";
    ServiceMessageType["AUTO_SHUT_DOWN"] = "AUTO_SHUT_DOWN";
    ServiceMessageType["AUTOMATIC"] = "AUTOMATIC";
    ServiceMessageType["CAR_STOP_SWITCH"] = "CAR_STOP_SWITCH";
    ServiceMessageType["DOOR_DISCONNECT"] = "DOOR_DISCONNECT";
    ServiceMessageType["EMERGENCY_DISPATCH"] = "EMERGENCY_DISPATCH";
    ServiceMessageType["EMERGENCY_POWER"] = "EMERGENCY_POWER";
    ServiceMessageType["EXPRESS_OPERATION"] = "EXPRESS_OPERATION";
    ServiceMessageType["FRONT_DOOR_HOLD"] = "FRONT_DOOR_HOLD";
    ServiceMessageType["FRONT_NUDGING"] = "FRONT_NUDGING";
    ServiceMessageType["INCONSPICUOUS_RISER"] = "INCONSPICUOUS_RISER";
    ServiceMessageType["INDEPENDENT"] = "INDEPENDENT";
    ServiceMessageType["LOAD_WEIGHER"] = "LOAD_WEIGHER";
    ServiceMessageType["LOBBY_RECALL"] = "LOBBY_RECALL";
    ServiceMessageType["LOBBY_STOP"] = "LOBBY_STOP";
    ServiceMessageType["LOCKDOWN_OPERATION"] = "LOCKDOWN_OPERATION";
    ServiceMessageType["MASS_MEDICAL"] = "MASS_MEDICAL";
    ServiceMessageType["NEONATAL_SERVICE"] = "NEONATAL_SERVICE";
    ServiceMessageType["NEXT_UP"] = "NEXT_UP";
    ServiceMessageType["PARKING"] = "PARKING";
    ServiceMessageType["REAR_DOOR_HOLD"] = "REAR_DOOR_HOLD";
    ServiceMessageType["REAR_NUDGING"] = "REAR_NUDGING";
    ServiceMessageType["REDUCED_POWER_OPERATION"] = "REDUCED_POWER_OPERATION";
    ServiceMessageType["RUN_MOTOR"] = "RUN_MOTOR";
    ServiceMessageType["SABBATH"] = "SABBATH";
    ServiceMessageType["SAFETY_STRING"] = "SAFETY_STRING";
    ServiceMessageType["SELECTOR"] = "SELECTOR";
    ServiceMessageType["SERVICE_CALL_OPERATION"] = "SERVICE_CALL_OPERATION";
    ServiceMessageType["SERVICE_PROTECT"] = "SERVICE_PROTECT";
    ServiceMessageType["STANDBY"] = "STANDBY";
    ServiceMessageType["TENANT_SECURITY"] = "TENANT_SECURITY";
    ServiceMessageType["VIP_SERVICE"] = "VIP_SERVICE";
    //
    // KW
    //
    ServiceMessageType["PLEASE_WAIT"] = "PLEASE_WAIT";
    ServiceMessageType["PLEASE_SPEAK"] = "PLEASE_SPEAK";
    ServiceMessageType["SPECIAL_OPERATION"] = "SPECIAL_OPERATION";
    ServiceMessageType["LOADING_OPERATION"] = "LOADING_OPERATION";
    ServiceMessageType["HOSPITAL_BED_TRAVEL"] = "HOSPITAL_BED_TRAVEL";
    ServiceMessageType["SERVICE_OPERATION"] = "SERVICE_OPERATION";
    //
    // Miscellaneous CAN's
    //
    ServiceMessageType["EN81_28"] = "EN81_28";
    ServiceMessageType["EN81_72"] = "EN81_72";
    ServiceMessageType["LEAVE_CABIN"] = "LEAVE_CABIN";
    ServiceMessageType["MAINTENANCE"] = "MAINTENANCE";
    ServiceMessageType["MOVING"] = "MOVING";
    ServiceMessageType["RESERVED"] = "RESERVED";
    ServiceMessageType["SEISMIC"] = "SEISMIC";
    //
    // CANOPEN
    //
    // Image only
    ServiceMessageType["SI_BED_TRANSPORT"] = "SI_BED_TRANSPORT";
    ServiceMessageType["SI_FIRE_SERVICE"] = "SI_FIRE_SERVICE";
    ServiceMessageType["SI_FULL_LOAD"] = "SI_FULL_LOAD";
    ServiceMessageType["SI_GUEST_CALL"] = "SI_GUEST_CALL";
    ServiceMessageType["SI_HELP_IS_COMING"] = "SI_HELP_IS_COMING";
    ServiceMessageType["SI_MAINTENANCE"] = "SI_MAINTENANCE";
    ServiceMessageType["SI_MOVING"] = "SI_MOVING";
    ServiceMessageType["SI_NO_LOAD"] = "SI_NO_LOAD";
    ServiceMessageType["SI_OUT_OF_ORDER"] = "SI_OUT_OF_ORDER";
    ServiceMessageType["SI_PRIORITY"] = "SI_PRIORITY";
    ServiceMessageType["SI_RESCUE_OPERATION"] = "SI_RESCUE_OPERATION";
    ServiceMessageType["SI_TRAVEL_TO_FIRE_ALARM_FLOOR"] = "SI_TRAVEL_TO_FIRE_ALARM_FLOOR";
    ServiceMessageType["SI_TRAVEL_TO_FIRE_RECALL_FLOOR"] = "SI_TRAVEL_TO_FIRE_RECALL_FLOOR";
    ServiceMessageType["SI_VIP_TRANSPORT"] = "SI_VIP_TRANSPORT";
    // Image and/or audio
    ServiceMessageType["SI_VMU_EME_OPERATION"] = "SI_VMU_EME_OPERATION";
    ServiceMessageType["SI_VMU_FIRE_SERVICE"] = "SI_VMU_FIRE_SERVICE";
    ServiceMessageType["SI_VMU_MIND_STEP"] = "SI_VMU_MIND_STEP";
    ServiceMessageType["SI_VMU_OVERLOAD"] = "SI_VMU_OVERLOAD";
    // Audio only
    ServiceMessageType["VMU_CLEAR_DOOR"] = "VMU_CLEAR_DOOR";
    ServiceMessageType["VMU_DOOR_OPENING"] = "VMU_DOOR_OPENING";
    ServiceMessageType["VMU_DOOR_CLOSING"] = "VMU_DOOR_CLOSING";
    ServiceMessageType["VMU_EME_CALL_IN_PROG"] = "VMU_EME_CALL_IN_PROG";
    ServiceMessageType["VMU_EME_CALL_IS_ESTAB"] = "VMU_EME_CALL_IS_ESTAB";
    ServiceMessageType["VMU_LEAVE_CABIN"] = "VMU_LEAVE_CABIN";
    ServiceMessageType["VMU_MAINTENANCE"] = "VMU_MAINTENANCE";
    ServiceMessageType["VMU_OUT_OF_ORDER"] = "VMU_OUT_OF_ORDER";
    ServiceMessageType["VMU_PLEASE_SPEAK"] = "VMU_PLEASE_SPEAK";
    ServiceMessageType["VMU_SELECT_DESTINATION"] = "VMU_SELECT_DESTINATION";
    ServiceMessageType["VMU_WAIT_FOR_RESCUE"] = "VMU_WAIT_FOR_RESCUE";
    //
    // CANOPEN (SCH)
    //
    ServiceMessageType["COLLECTING_PASSENGERS_DOWN"] = "COLLECTING_PASSENGERS_DOWN";
    ServiceMessageType["COLLECTING_PASSENGERS_UP"] = "COLLECTING_PASSENGERS_UP";
    ServiceMessageType["ELEVATOR_OUT_OF_SERVICE"] = "ELEVATOR_OUT_OF_SERVICE";
    ServiceMessageType["ELEVATOR_NEEDED"] = "ELEVATOR_NEEDED";
    ServiceMessageType["EVACUATING_DOWN"] = "EVACUATING_DOWN";
    ServiceMessageType["EVACUATING_UP"] = "EVACUATING_UP";
    ServiceMessageType["EXIT_AT_EVAC_FLOOR"] = "EXIT_AT_EVAC_FLOOR";
    ServiceMessageType["FIRE_RETURN_TO_ALT_FLOOR"] = "FIRE_RETURN_TO_ALT_FLOOR";
    ServiceMessageType["FIRE_RETURN_TO_MAIN_FLOOR"] = "FIRE_RETURN_TO_MAIN_FLOOR";
    ServiceMessageType["LOADING_DO_NOT_EXIT"] = "LOADING_DO_NOT_EXIT";
    ServiceMessageType["MEDICAL_EMERGENCY"] = "MEDICAL_EMERGENCY";
    ServiceMessageType["NUDGING_BUZZER"] = "NUDGING_BUZZER";
    ServiceMessageType["OTHER_DECK_SERVED"] = "OTHER_DECK_SERVED";
})(ServiceMessageType || (ServiceMessageType = {}));
export var Currency;
(function (Currency) {
    Currency["CAD"] = "cad";
    Currency["USD"] = "usd";
})(Currency || (Currency = {}));
export var ContractType;
(function (ContractType) {
    ContractType["Monthly"] = "m";
    ContractType["FixedTerm"] = "f";
})(ContractType || (ContractType = {}));
export var BillingService;
(function (BillingService) {
    BillingService["Data"] = "data";
    BillingService["Insights"] = "insights";
    BillingService["PhoneAnswering"] = "phoneAnswering";
    BillingService["RemoteAccess"] = "remoteAccess";
    BillingService["VOIP"] = "voip";
})(BillingService || (BillingService = {}));
export var SsoProviderType;
(function (SsoProviderType) {
    SsoProviderType["Okta"] = "okta";
    SsoProviderType["EntraId"] = "entraid";
})(SsoProviderType || (SsoProviderType = {}));
export var SsoProviderName = (_a = {},
    _a[SsoProviderType.Okta] = 'Okta',
    _a[SsoProviderType.EntraId] = 'Entra ID',
    _a);
export var EcsDeviceStatus = {
    Offline: -2,
    Failed: -1,
    Unknown: 0,
    NotReady: 1,
    Online: 2,
};
export var DeviceStatus;
(function (DeviceStatus) {
    DeviceStatus["Offline"] = "--";
    DeviceStatus["Up"] = "UP";
    DeviceStatus["Late1"] = "L1";
    DeviceStatus["Late2"] = "L2";
    DeviceStatus["Down"] = "DN";
})(DeviceStatus || (DeviceStatus = {}));
export var DeviceFamily;
(function (DeviceFamily) {
    DeviceFamily["MatisseR4"] = "MatisseR4";
    DeviceFamily["MatisseR5"] = "MatisseR5";
    DeviceFamily["Giotto"] = "Giotto";
    DeviceFamily["Raffaello"] = "Raffaello";
    DeviceFamily["TTG"] = "TTG";
    DeviceFamily["MatisseFlexR2"] = "MatisseFlexR2";
})(DeviceFamily || (DeviceFamily = {}));
export var DeviceFamilyNames = (_b = {},
    _b[DeviceFamily.MatisseR4] = "Matisse R4",
    _b[DeviceFamily.MatisseR5] = "Matisse R5",
    _b[DeviceFamily.Giotto] = "Giotto",
    _b[DeviceFamily.Raffaello] = "Raffaello",
    _b[DeviceFamily.TTG] = "TTG",
    _b[DeviceFamily.MatisseFlexR2] = "MatisseFlexR2",
    _b);
export var DeviceClass = {
    Unknown: "unknown",
    Router: "router",
    Gateway: "gateway",
    Display: "display",
    Camera: "camera",
    Relay: "relay",
    LobbyPanel: "lobbypanel",
    Modem: "modem",
    ATA: "ata",
    SIMCard: "simcard",
};
export var GroupType = {
    MachineRoom: 'MR',
    Elevator: 'EL',
    OrganizingGroup: 'OG',
};
export var AssetType;
(function (AssetType) {
    AssetType["Image"] = "image";
    AssetType["Video"] = "video";
    AssetType["Audio"] = "audio";
    AssetType["Text"] = "text";
    AssetType["News"] = "news";
    AssetType["DateTime"] = "datetime";
    AssetType["Time"] = "time";
    AssetType["Clock"] = "clock";
    AssetType["Theme"] = "theme";
    AssetType["Stocks"] = "stocks";
    AssetType["Rtsp"] = "rtsp";
    AssetType["Weather"] = "weather";
    AssetType["Html"] = "html";
    AssetType["Traffic"] = "traffic";
    // PI widgets:
    AssetType["MaxPersons"] = "maxPersons";
    AssetType["MaxWeight"] = "maxWeight";
    AssetType["ElevatorId"] = "elevatorId";
    AssetType["Floor"] = "floor";
    AssetType["Direction"] = "direction";
    AssetType["Logo"] = "logo";
    AssetType["CeNumber"] = "ceNumber";
    AssetType["FreeText1"] = "freeText1";
    AssetType["FreeText2"] = "freeText2";
    AssetType["FreeText3"] = "freeText3";
    AssetType["FreeText4"] = "freeText4";
    AssetType["Details1"] = "details1";
    AssetType["Details2"] = "details2";
    AssetType["Details3"] = "details3";
    AssetType["Details4"] = "details4";
    // ECS widgets:
    AssetType["Symbol"] = "symbol";
})(AssetType || (AssetType = {}));
export var ScaleMode = {
    Normal: "normal",
    Stretch: "stretch",
    Fit: "fit",
    Cover: "cover",
};
export var TextSource;
(function (TextSource) {
    TextSource["Custom"] = "custom";
    TextSource["Signal"] = "signal";
    TextSource["Protocol"] = "protocol";
})(TextSource || (TextSource = {}));
export var ImageSource;
(function (ImageSource) {
    ImageSource["Custom"] = "custom";
    ImageSource["Signal"] = "signal";
    ImageSource["En8172"] = "en8172";
    ImageSource["Emergency"] = "emergency";
})(ImageSource || (ImageSource = {}));
export var NewsFormat;
(function (NewsFormat) {
    NewsFormat["Headline"] = "headline";
    NewsFormat["Details"] = "details";
    NewsFormat["Thumbnail"] = "thumbnail";
    NewsFormat["Backdrop"] = "backdrop";
})(NewsFormat || (NewsFormat = {}));
export var ThemeStatus = {
    Idle: "--",
    Queued: "QU",
    InProgress: "IP",
    Error: "ER",
};
export var VideoCallRejectReason = {
    OnCall: 1,
    Unsolicited: 2,
    ServerError: 3,
    BuildingUnreachable: 4,
};
export var CacheId;
(function (CacheId) {
    CacheId["main"] = "main";
    CacheId["checkin"] = "checkin";
})(CacheId || (CacheId = {}));
